import httpManager from "@/app/shared/utils/httpManager";
// import { TABLE_PAGE_SIZE } from "@/app/shared/utils/constants";

export async function fetchWhatsappExpenses({ filters, page = 1 } = {}) {
  // const limit = TABLE_PAGE_SIZE;
  // const offset = (page - 1) * TABLE_PAGE_SIZE;

  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";
  const channel_customer = filters?.channel_customers
    ? JSON.stringify(filters.channel_customers)
    : "";

  const url = `/billing/charges/whatsapp/`;
  // const query = `?limit=${limit}&offset=${offset}&channel_customer=${channel_customer}&start_date=${startDate}&end_date=${endDate}`;
  const query = `?channel_customer=${channel_customer}&start_date=${startDate}&end_date=${endDate}`;

  const response = await httpManager.get(`${url}${query}`);
  return response.data;
}

export async function fetchWhatsappVoiceExpenses({ filters, page = 1 } = {}) {
  // const limit = TABLE_PAGE_SIZE;
  // const offset = (page - 1) * TABLE_PAGE_SIZE;

  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";
  const channel_customer = filters?.channel_customers
    ? JSON.stringify(filters.channel_customers)
    : "";

  const url = `/billing/charges/whatsapp-voice/`;
  // const query = `?limit=${limit}&offset=${offset}&channel_customer=${channel_customer}&start_date=${startDate}&end_date=${endDate}`;
  const query = `?channel_customer=${channel_customer}&start_date=${startDate}&end_date=${endDate}`;

  const response = await httpManager.get(`${url}${query}`);
  return response.data;
}

export async function fetchVoiceExpenses({ filters } = {}) {
  // const limit = TABLE_PAGE_SIZE;
  // const offset = (page - 1) * TABLE_PAGE_SIZE;

  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";
  // const dialplans = filters?.dialplan ? JSON.stringify(filters.dialplan) : "";

  const url = `/billing/charges/calls/`;
  // const query = `?limit=${limit}&offset=${offset}&channel_customer=${channel_customer}&start_date=${startDate}&end_date=${endDate}`;
  const query = `?start_date=${startDate}&end_date=${endDate}`;

  const response = await httpManager.get(`${url}${query}`);
  return response.data;
}

export async function fetchTotalExpenses({ filters } = {}) {
  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";
  const channel_customer = filters?.channel_customers
    ? JSON.stringify(filters.channel_customers)
    : "";

  const url = `/billing/charges/total/`;
  const query = `?channel_customer=${channel_customer}&start_date=${startDate}&end_date=${endDate}`;

  const response = await httpManager.get(`${url}${query}`);
  return response.data;
}

export async function downloadExpenses({ filters } = {}) {
  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";
  // const channel_customer = filters?.channel_customers
  //   ? JSON.stringify(filters.channel_customers)
  //   : "";

  const url = `/billing/charges/whatsapp/download/`;
  const query = `?start_date=${startDate}&end_date=${endDate}`;

  const response = await httpManager.getBlob(`${url}${query}`);
  return response;
}

export async function downloadWhatsappVoiceExpenses({ filters } = {}) {
  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";
  const channel_customer = filters?.channel_customers
    ? JSON.stringify(filters.channel_customers)
    : "";

  const url = `/billing/charges/whatsapp-voice/download/`;
  const query = `?channel_customer=${channel_customer}&start_date=${startDate}&end_date=${endDate}`;

  const response = await httpManager.getBlob(`${url}${query}`);
  return response;
}

export async function downloadVoiceExpenses({ filters } = {}) {
  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";
  const dialplans = filters?.dialplan ? JSON.stringify(filters.dialplan) : "";

  const url = `/billing/charges/calls/download/`;
  const query = `?dialing_rule=${dialplans}&start_date=${startDate}&end_date=${endDate}`;

  const response = await httpManager.getBlob(`${url}${query}`);
  return response;
}

export async function fetchSmsExpenses({ filters } = {}) {
  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";

  const url = `/billing/charges/sms/`;
  const query = `?start_date=${startDate}&end_date=${endDate}`;

  const response = await httpManager.get(`${url}${query}`);
  return response.data;
}

export async function downloadSmsExpenses({ filters } = {}) {
  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";

  const url = `/billing/charges/sms/download/`;
  const query = `?start_date=${startDate}&end_date=${endDate}`;

  const response = await httpManager.getBlob(`${url}${query}`);
  return response;
}
